import React, {Component} from 'react';
import LineItem from './LineItem';

class Cart extends Component {
  constructor(props) {
    super(props);

    this.openCheckout = this.openCheckout.bind(this);
  }

  openCheckout() {
    window.open(this.props.checkout.webUrl);
  }

  renderCartItems(line_items) {
    return (
      <div>
        <ul className="Cart__line-items">
          {line_items}
        </ul>
        <footer className="Cart__footer">
          <div className="Cart-info clearfix">
            <div className="Cart-info__total Cart-info__small">Subtotal</div>
            <div className="Cart-info__pricing">
              <span className="pricing">$ {this.props.checkout.subtotalPrice}</span>
            </div>
          </div>
          
          Shipping & taxes calculated at checkout
          <button className="Cart__checkout button" onClick={this.openCheckout}>Checkout</button>
        </footer>
    </div>);
  }

  renderEmptyCart() {
    return (
      <div className="cart-empty">Your cart is currently empty.</div>
    )
  }

  render() {
    let line_items = this.props.checkout.lineItems.map((line_item) => {
      return (
        <LineItem
          updateQuantityInCart={this.props.updateQuantityInCart}
          removeLineItemInCart={this.props.removeLineItemInCart}
          key={line_item.id.toString()}
          line_item={line_item}
        />
      );
    });

    return (
      <div className={`Cart ${this.props.isCartOpen ? 'Cart--open' : ''}`}>
        <header className="Cart__header">
          <h2>Shopping cart</h2>
          <button
            onClick={this.props.handleCartClose}
            className="Cart__close">
            ×
          </button>
        </header>
        {line_items.length > 0 ? this.renderCartItems(line_items) : this.renderEmptyCart()}
      </div>
    )
  }
}

export default Cart;



// WEBPACK FOOTER //
// ./src/components/Cart.js